export default __webpack_public_path__ + "static/media/verifiedVendor.2ba25da4.png";